enum WorkspaceSubscriptionPaymentProvider {
  'private' = 'private',
  'stripe' = 'stripe',
}

export default WorkspaceSubscriptionPaymentProvider
